var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16V14H16.1875V16H21.5ZM21.5 20V18H16.1875V20H21.5ZM14.8125 10V3.3125H12.1875V10H14.8125ZM13.5 22V21C13.5 20.4167 13.0417 19.9375 12.125 19.5625C11.2083 19.1875 10.3333 19 9.5 19C8.66667 19 7.79167 19.1875 6.875 19.5625C5.95833 19.9375 5.5 20.4167 5.5 21V22H13.5ZM10.9375 14.5625C10.5625 14.1875 10.0833 14 9.5 14C8.91667 14 8.4375 14.1875 8.0625 14.5625C7.6875 14.9375 7.5 15.4167 7.5 16C7.5 16.5833 7.6875 17.0625 8.0625 17.4375C8.4375 17.8125 8.91667 18 9.5 18C10.0833 18 10.5625 17.8125 10.9375 17.4375C11.3125 17.0625 11.5 16.5833 11.5 16C11.5 15.4167 11.3125 14.9375 10.9375 14.5625ZM24.1875 7.3125C24.8958 7.3125 25.5 7.58333 26 8.125C26.5417 8.66667 26.8125 9.29167 26.8125 10V24.6875C26.8125 25.3958 26.5417 26.0208 26 26.5625C25.5 27.0625 24.8958 27.3125 24.1875 27.3125H2.8125C2.10417 27.3125 1.47917 27.0625 0.9375 26.5625C0.4375 26.0208 0.1875 25.3958 0.1875 24.6875V10C0.1875 9.29167 0.4375 8.66667 0.9375 8.125C1.47917 7.58333 2.10417 7.3125 2.8125 7.3125H9.5V3.3125C9.5 2.60417 9.77083 2 10.3125 1.5C10.8542 0.958333 11.4792 0.6875 12.1875 0.6875H14.8125C15.5208 0.6875 16.1458 0.958333 16.6875 1.5C17.2292 2 17.5 2.60417 17.5 3.3125V7.3125H24.1875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.6c00a9ab2ee8ccc27ec0c110e9dadc16.svg";
export { ForwardRef as ReactComponent };